import { QuestDefinition } from './types';

/**
 * Quest definition for the Camera Orientation tool (CameraOrientationTool / 'camera_orientation')
 *
 * Maps internal stages to user-facing tooltip translation source strings.
 * These strings must be registered in apps/client/src/translation/questTranslations.ts
 * for the extraction CLI to pick them up.
 */
export const cameraOrientationQuest: QuestDefinition = {
  toolName: 'camera_orientation',
  states: {},
  defaultKey: 'click and drag to set the camera direction',
};
